import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IonModal, IonContent, IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";

import { AuthenticatedPage, CircleIconButton } from "../../../common";
import { AccountInformationDisplay } from "../../containers";
import { updateAccountInformation } from "../../modules";
import strings from "../../../../res/strings";

import styled from "styled-components";
const Modal = styled(IonModal)`
  --min-width: 50vw;
  --min-height: 80vh;
  --border-radius: 20px;
  --border-color: rgba(0, 204, 204, 0.3);
`;
const CloseButtonIcon = styled(IonIcon)`
  color: #ffffff;
  font-weight: bold;
  font-size: 1.5em;
`;

let AccountInformationModal = (props) => {
  const contentRef = useRef();
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [
    activeEditCloseHandler,
    setActiveEditCloseHandler,
  ] = useState(() => () => {});

  const openActiveFormEdit = (handleCancel) => {
    setActiveEditCloseHandler(() => () => handleCancel());
  };

  const closeActiveFormEdit = () => {
    setSelectedImages([]);

    if (activeEditCloseHandler) {
      activeEditCloseHandler();
    }
  };

  const submitEditedAccountInformation = (values) => {
    if (selectedImages && selectedImages.length > 0) {
      values.avatar = selectedImages[0];
    }

    values.user_authtoken = props.credentials.authToken;

    props.updateAccountInformation({
      values,
      content: contentRef,
      closeActiveFormEdit,
      successState: {
        notificationType: "toast",
        context: "lib_account.updateAccountInformation.AccountInformationPage",
        message: strings.lib_common_state_success_update_saved,
      },
      errorState: (error) => ({
        ...error,
        notificationType: "alert",
        context: "lib_account.updateAccountInformation.AccountInformationPage",
      }),
    });
  };

  return (
    <Modal
      {...props}
      onDidDismiss={() => {
        props.handleClose();
      }}
    >
      <IonContent>
        <CircleIconButton
          style={{
            width: "40px",
            height: "40px",
            float: "right",
            marginTop: "16px",
            marginRight: "16px",
          }}
          onClick={props.handleClose}
        >
          <CloseButtonIcon icon={closeOutline} />
        </CircleIconButton>
        {props.accountInformation && (
          <AccountInformationDisplay
            accountInformation={props.accountInformation}
            onSubmit={submitEditedAccountInformation}
            openActiveFormEdit={openActiveFormEdit}
            closeActiveFormEdit={closeActiveFormEdit}
            selectedImages={selectedImages}
            setSelectedImages={setSelectedImages}
          />
        )}
      </IonContent>
    </Modal>
  );
};

const mapStateToPropsModal = (state) => ({
  credentials: state.lib_authentication.credentials,
  accountInformation: state.lib_account.accountInformation,
});
const mapDispatchToPropsModal = (dispatch) =>
  bindActionCreators(
    {
      updateAccountInformation,
    },
    dispatch
  );
AccountInformationModal = connect(
  mapStateToPropsModal,
  mapDispatchToPropsModal
)(AccountInformationModal);
export { AccountInformationModal };

let AccountInformationPage = (props) => {
  const history = useHistory();
  const contentRef = useRef();
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [
    activeEditCloseHandler,
    setActiveEditCloseHandler,
  ] = useState(() => () => {});

  const openActiveFormEdit = (handleCancel) => {
    setActiveEditCloseHandler(() => () => handleCancel());
  };

  const closeActiveFormEdit = () => {
    setSelectedImages([]);

    if (activeEditCloseHandler) {
      activeEditCloseHandler();
    }
  };

  const submitEditedAccountInformation = (values) => {
    if (selectedImages && selectedImages.length > 0) {
      values.avatar = selectedImages[0];
    }

    values.user_authtoken = props.credentials.authToken;

    props.updateAccountInformation({
      values,
      content: contentRef,
      closeActiveFormEdit,
      successState: {
        notificationType: "toast",
        context: "lib_account.updateAccountInformation.AccountInformationPage",
        message: strings.lib_common_state_success_update_saved,
      },
      errorState: (error) => ({
        ...error,
        notificationType: "alert",
        context: "lib_account.updateAccountInformation.AccountInformationPage",
      }),
    });
  };

  return (
    <AuthenticatedPage
      ref={contentRef}
      title={strings.lib_account_title_account_information}
      history={history}
      breadcrumbPath={[
        {
          label: "Account Information",
          url: "/account-information",
        },
      ]}
    >
      {props.accountInformation && (
        <AccountInformationDisplay
          accountInformation={props.accountInformation}
          onSubmit={submitEditedAccountInformation}
          openActiveFormEdit={openActiveFormEdit}
          closeActiveFormEdit={closeActiveFormEdit}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
        />
      )}
    </AuthenticatedPage>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
  accountInformation: state.lib_account.accountInformation,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAccountInformation,
    },
    dispatch
  );

AccountInformationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountInformationPage);
export default AccountInformationPage;
